import { React } from '@common/3rd';
import { checkAllRuntimeComponents, Widget } from '@component';
import { DeskQueryProps, JLPanel, JLSpreadSheet } from '@jl-types';
import { Modeller } from '@model';
import { CheckableWidgetCheckResult, PaginationChangeEvent } from '@my-types';
import { DeskContainer } from '../container/desk-container';

class DeskQuery<P extends DeskQueryProps, S, C> extends Widget<P, S, C> {
	protected initComponents(): C {
		return {} as C;
	}
	render() {
		return <DeskContainer model={this.getModel()} layout={this.getLayout()} />;
	}
	/**
	 * 是否需要分页
	 */
	private needPagination(): boolean {
		return this.getModel().pagination != null;
	}
	private getModel() {
		return Modeller.asProxied(this.props.model);
	}
	private getLayout() {
		const layout = this.props.layout;
		return [
			{
				c: 'panel',
				header: { title: layout.criteria.title },
				body: layout.criteria.body
			} as JLPanel,
			{
				c: 'panel',
				header: { title: layout.results.title },
				body: {
					css: () => 'padding-top: 0;',
					cells: {
						c: 'panel.body.cell',
						children: {
							c: 'spread',
							css: () => 'flex-grow: 1;',
							header: layout.results.header,
							body: layout.results.body,
							footer: this.needPagination()
								? {
										children: {
											c: 'pagination',
											id: 'pagination',
											onPageChanged: this.onPageChanged
										}
								  }
								: undefined
						} as JLSpreadSheet
					}
				}
			} as JLPanel
		];
	}
	getFetchFunction() {
		return this.props.fetch;
	}
	onPageChanged = (changed: PaginationChangeEvent): void => {
		const { pageNumber, pageCount, pageSize } = changed;
		this.getFetchFunction()
			.call(this, { pageNumber, pageCount, pageSize })
			.then(() => {
				this.forceUpdate();
			});
	};
	checkAllData(): Promise<CheckableWidgetCheckResult[] | void> {
		return checkAllRuntimeComponents();
	}
}

export { DeskQuery };
